export default {
    exportCsvData(exportData, fileName) {
        const csvData = exportData.map((e) => e.join(',')).join('\n')

        // Create a Blob and temporary link
        const blob = new Blob([csvData], { type: 'text/csv charset=utf-8' })
        const link = document.createElement('a')

        link.href = URL.createObjectURL(blob)
        link.download = fileName

        // Append to DOM, click, and clean up
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }
}
